/**
 * Guardián del puntero (2026-08-20). El Select de Radix pone
 * `pointer-events: none` en el <body> mientras está abierto; en la tablet a
 * veces NO lo quitaba al cerrarse y la página entera quedaba muerta al tacto
 * (nadie podía firmar la LOPD: «el formulario está fallando»). La librería va
 * actualizada, y además este vigilante suelta el candado si se queda puesto
 * sin ninguna capa abierta. Barato (1 comprobación/segundo) y a prueba de
 * regresiones futuras de la librería.
 */
import { useEffect } from 'react';

export default function GuardianPuntero() {
  useEffect(() => {
    const id = setInterval(() => {
      // OJO: la capa puede quedarse MONTADA con data-state="closed" para
      // siempre (así se reprodujo el fallo) — cuenta solo lo que esté "open".
      const capaAbierta = document.querySelector(
        '[data-radix-popper-content-wrapper] [data-state="open"], '
        + '[data-state="open"][role="listbox"], [data-state="open"][role="dialog"]'
      );
      if (!capaAbierta && document.body.style.pointerEvents === 'none') {
        document.body.style.pointerEvents = '';
      }
      // Y la capa fantasma en sí: cerrada pero montada, queda flotando
      // ENCIMA del formulario y se traga los toques (nadie podía firmar).
      // Se le quita el puntero mientras esté cerrada; si reabre, se le
      // devuelve.
      document.querySelectorAll('[data-radix-popper-content-wrapper]').forEach((w) => {
        w.style.pointerEvents = w.querySelector('[data-state="open"]') ? '' : 'none';
      });
    }, 1000);
    return () => clearInterval(id);
  }, []);
  return null;
}
